"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstructionStatus = exports.TrustedClaimIssuerOperation = exports.isResolverFunction = void 0;
/**
 * @hidden
 */
function isResolverFunction(value) {
    return typeof value === 'function';
}
exports.isResolverFunction = isResolverFunction;
var TrustedClaimIssuerOperation;
(function (TrustedClaimIssuerOperation) {
    TrustedClaimIssuerOperation["Remove"] = "Remove";
    TrustedClaimIssuerOperation["Add"] = "Add";
    TrustedClaimIssuerOperation["Set"] = "Set";
})(TrustedClaimIssuerOperation = exports.TrustedClaimIssuerOperation || (exports.TrustedClaimIssuerOperation = {}));
var InstructionStatus;
(function (InstructionStatus) {
    InstructionStatus["Pending"] = "Pending";
    InstructionStatus["Unknown"] = "Unknown";
    InstructionStatus["Failed"] = "Failed";
    InstructionStatus["Success"] = "Success";
    InstructionStatus["Rejected"] = "Rejected";
})(InstructionStatus = exports.InstructionStatus || (exports.InstructionStatus = {}));
//# sourceMappingURL=internal.js.map